import React, { useEffect, useState } from "react"
import { defPath, fetchPath } from '../../config/defPath'
import { useModal, useSession } from "../../hooks/useState"
import Alert from "./Alert"
import { BtnComprar } from "../tadaShop/BtnComprar"

import { useGeneralConfig } from "../../hooks/useGeneralConfig"


const NewHeader = ({logo, showButtons = true}: {logo?: string| null, showButtons?: boolean}) => {
  const { openModal, isOpen, closeModal } = useModal(state => state)
  const { logged, coins, points, user, validateSession, resetState } = useSession(state => state)
  const getGeneralConfig = useGeneralConfig(state => state.getGeneralConfig)

  useEffect(() => {
    if (window.drupalSettings && window.drupalSettings.user.uid !== 0){
      // console.log('new header session')
      validateSession()
    } else {
      resetState()
    }
    // getGeneralConfig()
    if (typeof(Storage) !== 'undefined') {
      const generalConfig = JSON.parse(sessionStorage.getItem('general-estadio'))
      // console.log('general-estadio', sessionStorage.getItem('general-estadio'), generalConfig)
      if (generalConfig !== 'undefined') {
        if (generalConfig.state.video == 'INIT') {
          getGeneralConfig()
        }
      }
    } 
  }, [])

  useEffect(() => {
    const footer = document.querySelector('footer.site-footer') as HTMLElement
    if (isOpen) {
      footer && footer.classList.add('footer-modo-carrera')
    } else {
      footer && footer.classList.remove('footer-modo-carrera')
    }
  }, [isOpen])

  const getFullName = () => {
    if (!user) return ""
    const firstName = user.name.split(' ')[0];
    const lastName = user.lastname.split(' ')[0];
    const lastNameRender = lastName?.length > 8 ? lastName : lastName.split('')[0]
    return `${firstName} ${firstName.length < 15 ? lastNameRender : '' }`;
  }
  // getFullName()

  const handleClickLogin = (event: any) => {
    // const text = event.target.closest('.brushTextTop').children[0].textContent;
    if (logged) {
      window.dataLayer.push({
        'event': 'GAEvent',
        'event_category': 'Content',
        'event_action': 'Button',
        'event_label': 'User Zone My Prizes',
        'interaction': 'true',
        'component_name': 'Modo_Carrera_UserZone',
        'element_text': 'Menú',
      });
      return
    };
    window.location.href = "/estadio-aguila/iniciar-sesion"
    //@ts-ignore
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Button',
      'event_label': 'Login',
      'interaction': 'true',
      'component_name': 'Modo_Carrera_LoginRegistro',
      'element_text': 'Iniciar Sesión',
    });
  }

  const handleClickRegister = () => {
    if (logged) {
      window.dataLayer.push({
        'event': 'GAEvent',
        'event_category': 'Content',
        'event_action': 'Button',
        'event_label': 'User Zone My Prizes',
        'interaction': 'true',
        'component_name': 'Modo_Carrera_UserZone',
        'element_text': 'Menú',
      });
      return
    };
    // @ts-ignore
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Button',
      'event_label': 'Register',
      'interaction': 'true',
      'component_name': 'Modo_Carrera_LoginRegistro',
      'element_text': 'Registro',
    });
    window.location.href = '/estadio-aguila/registro'
  }

  const handleClick = () => {
    openModal('menu_profile')
    // @ts-ignore
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Button',
      'event_label': 'Career Mode Menu',
      'interaction': 'true',
      'component_name': 'Modo_Carrera_Menu',
      'element_text': 'Menú',
    });
  }

  const handleClose = () => {
    // @ts-ignore
    window.soundController && window.soundController.play('cerrar', false, 1)
    if (document.querySelector('.ar__modal_overlay .ar__alert_register')) {
      // @ts-ignore
      window.dataLayer.push({
        'event': 'GAEvent',
        'event_category': 'Content',
        'event_action': 'Button',
        'event_label': 'Close Unregistered user',
        'interaction': 'true',
        'component_name': 'Modo_Carrera_PopUp_Registrate',
        'element_text': 'Cerrar',
      });
    } else if (document.querySelector('.ar__modal_overlay .ar__menu_profile.logged')) {
      // @ts-ignore
      window.dataLayer.push({
        'event': 'GAEvent',
        'event_category': 'Content',
        'event_action': 'Button',
        'event_label': 'Close Principal Menu',
        'interaction': 'true',
        'component_name': 'Modo_Carrera_PrincipalMenu',
        'element_text': 'Cerrar',
      });
    }
    closeModal()
  }

  return (
    <>
      <header className={`newHeaderAL ${isOpen && logged ? 'menuLoggedActive' : ''} ${isOpen && !logged ? 'menuNoLogged' : ''}`}>
        <div className={`newHeaderAL__body`}>
          {
          showButtons 
          && (
            <div className="newHeaderAL__btns">
            <div className="infoUser">
              <p className="textUser">Hola,</p>
              <p className="nameU subtitleSmall40">{getFullName()}</p>
            </div>
            <div className="newHeaderAL__btns__body">
              <div onClick={handleClickLogin} className={`brushTextTop ${logged ? 'brushText_red-right coinText' : 'brushText_yellow-right'}`}>
                {!logged ? (
                  <p className='black_24'>Iniciar <span>Sesión</span></p>
                ) : (
                  <p className="textCoins whiteShadow blur-slow">{coins}</p>
                )}
              </div>
              <div onClick={handleClickRegister} className={`brushTextBottom ${logged ? 'brushText_yellow-right coinText' : 'brushText_red-right'}`}>
                {!logged ? (
                  <p className='subtitleSmall40'>Registro</p>
                ) : (
                  <p className='subtitleSmall40 blur-slow'>{!points ? '0' : points}<span>puntos</span></p>
                )}
              </div>
            </div>
          </div>
          )
          }
          <div className="newHeaderAL__logoAguila">
            <a href='/estadio-aguila' className="logoAguila">
              <img src={logo || `${defPath}/assets/images/logo_aguila_new.png`} alt="Logo Estadio Aguila" />
            </a>
            {/* <div className="olas">
              <img className="ola1" src={`${defPath}/assets/images/newHeaderTopLogos/ola.png`} alt="Imagen olas" />
              <img className="ola2" src={`${defPath}/assets/images/newHeaderTopLogos/ola.png`} alt="Imagen olas" />
            </div>             */}
          </div>

          {!isOpen ? (
            <div onClick={handleClick} className="newHeaderAL__menu brushText_electricBlue-left">
              <div className="ballMenu">
                <img src={`${defPath}/assets/images/btn_ball.png`} alt="" />
              </div>
              <p className='subtitleSmall40'>Menú</p>
            </div>
          ) : (
            <a onClick={handleClose} className="close__modal"></a>
          )}
        </div>
        <div style={{ display: isOpen ? 'block' : 'none' }}>
          <BtnComprar isMenu />
        </div>
      </header>
      <Alert />
    </>
  )
}

export default NewHeader